import AddIcon from "@mui/icons-material/Add";
import { Box, DialogTitle, Divider, IconButton, Popover } from "@mui/material";
import { Button, Spacer, Toolbar } from "common";
import I18n from "i18n-js";
import { MouseEvent, useMemo, useState } from "react";
import { useFormEditor } from "./FormEditorDataProvider";
import Templates from "./Templates";
import templateDefs from "./templateDefs";
import { RowItem } from "./types";

export interface RowMenuProps {
  blockIndex: number;
  rowIndex: number;
  row: RowItem | null;
}
export default function RowMenu({ rowIndex, blockIndex, row }: RowMenuProps) {
  const { handleDeleteRow, handleAddTemplate, rowIsFull } = useFormEditor();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const templates = useMemo(() => {
    let groups = templateDefs.map(group => ({
      ...group,
      templates: group.templates.filter(template => {
        if (template.rows.length !== 1) {
          return false;
        }
        if (template.rows[0].fields.length !== 1) {
          return false;
        }
        if (template.rows[0].fields[0].full_width) {
          return false;
        }
        if (group.name === "Content") {
          return false;
        }
        return true;
      }),
    }));
    return groups.filter(group => group.templates.length > 0);
  }, []);

  return (
    <>
      <IconButton onClick={handleClick} size="small" disabled={rowIsFull(row)}>
        <AddIcon fontSize="small" />
      </IconButton>
      <Popover
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        /*MenuListProps={{
          "aria-labelledby": "basic-button",
        }}*/
      >
        <DialogTitle>
          {I18n.t("FormEditor.addFieldToRowTitle", { rowNumber: rowIndex + 1 })}
        </DialogTitle>
        <Box sx={{ padding: 2, paddingTop: 0 }}>
          <Box sx={{ maxWidth: 220 }}>
            <Templates
              templates={templates}
              handleAddTemplate={template => {
                handleAddTemplate(template, blockIndex, rowIndex);
              }}
            />
          </Box>
        </Box>
        <Divider />
        <Toolbar sx={{ padding: 1 }}>
          <Spacer right />
          <Button
            variant="text"
            color="error"
            title={I18n.t("FormEditor.removeRow")}
            onClick={() => handleDeleteRow({ blockIndex, rowIndex })}
          />
        </Toolbar>
      </Popover>
    </>
  );
}
